import { render } from "./BijiIntroduce.vue?vue&type=template&id=34150fb5&scoped=true"
import script from "./BijiIntroduce.vue?vue&type=script&lang=js"
export * from "./BijiIntroduce.vue?vue&type=script&lang=js"

import "./BijiIntroduce.vue?vue&type=style&index=0&id=34150fb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34150fb5"]])

export default __exports__